export default __webpack_public_path__ + "static/media/hardware-platform.9c007de7.svg";